<template>
  <DocusignThankYou
    :loading="loadingSignComplete || !successfulResponse"
    :document-type="$route.query.type"
    :img="image"
    :support-number="theme().novatedBrand?.support?.phone"
    :message="message"
  />
</template>

<script>
import { getAsset } from 'ecx.saigon.ui.common';
import { mapState, mapActions, mapGetters } from 'vuex';

export default {
  name: 'DocusignThankYouWidget',
  data() {
    return {
      successfulResponse: false,
      image: undefined
    };
  },
  computed: {
    ...mapState({
      loadingSignComplete: (state) => state.docusign.loadingSignComplete
    }),
    ...mapGetters('user', ['theme']),
    message() {
      const settlementType = this.$Constants.DOCUSIGN_DOCUMENT_TYPES.settlement;
      const employeeRole = this.$Constants.DOCUSIGN_ROLE_TYPES.employee;

      if (
        this.$route.query.type === settlementType &&
        this.$route.query.role === employeeRole
      ) {
        // eslint-disable-next-line
        return "We'll be in contact you when your car is ready for pick up.";
      }

      return '';
    }
  },
  methods: {
    ...mapActions('docusign', ['completeDocusign'])
  },
  async mounted() {
    const { role, applicationId, documentId } = this.$route.query;
    if (!role || !applicationId || !documentId) {
      return this.$router.push({ name: this.$RouteNames.dashboard });
    }

    this.image = await getAsset(this.$Constants.DOCUMENT_SIGNED_IMG_PATH);

    try {
      await this.completeDocusign({ role, applicationId, documentId });
      this.successfulResponse = true;
    } catch (e) {
      this.successfulResponse = false;
      return this.$router.push({ name: this.$RouteNames.dashboard });
    }
  },
  components: {
    DocusignThankYou: () =>
      import('../../components/molecule/docusign-thank-you')
  }
};
</script>
